import { useContext, useEffect } from "react"
import FieldBuilder from "./FieldBuilder"
import BlockActionBtns from "./BlockActionBtns"
import FormSummary from "./components/FormSummary"
import { FormContext } from "../../context/formContext"
import { useFormikContext } from "formik"
import _ from "lodash"

// Custom Blocks
import Assessments from "./CustomBlocks/Assessments"

import styles from "../../styles/Form.module.css"

export default function BlockBuilder({ block }) {
  const form = useContext(FormContext)
  const formik = useFormikContext()
  const isSubmitBlock = block?.block_name === "submit_block"
  const isCustomAssessmentBlock =
    block.block_name === "session__assessment" ||
    block.block_name === "session__assessment____custom"

  /* Monitor loading fields to reset form dirty state */
  useEffect(() => {
    // If not empty and all fields are loaded, mark block as loaded
    const loadingVals = Object.values(form.loadingFields || {})
    if (loadingVals.length > 0 && !loadingVals.some(v => v === true)) {
      // All registered fields are loaded
      formik.resetForm({ values: formik.values }) // Reset dirty state
      form.clearLoadingFields() // Clear loading fields
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.loadingFields])

  if (isCustomAssessmentBlock) {
    return <Assessments block={block} />
  }

  const renderActionButtons = (style) => {
    if (isSubmitBlock) return null
    return (
      <div className={style}>
        <BlockActionBtns block={block.block_name} />
      </div>
    )
  }

  return (
    <div key={block.block_name} className={styles.block}>
      <div className={styles.blockHeaderLayout}>
        <div className={styles.blockHeader}>
          <h2 className={styles.blockTitle}>{block.block_title}</h2>
          <p>
            {!isSubmitBlock && (
              <>
                <span className={styles.asterisk}>* </span>indicates required field{" "}
              </>
            )}
          </p>
        </div>
      </div>

      {renderActionButtons(styles.blockActions)}

      {/* Render normal block */}
      {!isSubmitBlock && (
        <FieldBuilder fields={block.fields} block={block.block_name} />
      )}

      {/* Render submit block */}
      {isSubmitBlock && <FormSummary />}

      {renderActionButtons(styles.blockActions)}
    </div >
  )
}
